export const OVERLAY_STATE = {
    LOGIN: 0,
    VG_REGISTER: 1,
    GOOGLE_REGISTER: 2
}